
import {SectionBgView} from '../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {SpriteView} from '../../../shared/scripts/ui_canvas_engine/SpriteView'
import {UIGameBankController} from '../../../shared/scripts/ui_game/UIGameBankController'
import {SectionView} from '../../../shared/scripts/ui_canvas_engine/SectionView'
import {CardCountView} from '../../../shared/scripts/ui_canvas_engine/CardCountView'
import {GameColor} from '../../../shared/scripts/GameColor'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {Sprites} from '../../../shared/scripts/ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../../shared/scripts/UIGameSpriteHandler'
import {UIGameProgressCardsToolTipView} from '../../../shared/scripts/ui_game/ui_game_tooltip/UIGameProgressCardsToolTipView'
import {TranslationObject} from '@colonist/i18n'
import {UIGameConstants} from '../../../shared/scripts/ui_game/UIGameConstants'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'
import {CardEnum, MechanicDevelopmentCardsState, MechanicProgressCardsState} from '@colonist/game-states'
import {UIMGameManager} from './UIMGameManager'

export class UIMGameBankController extends UIGameBankController {
    constructor(uiGameManager: UIMGameManager, devCardsState: MechanicDevelopmentCardsState | undefined, progressCardsState: MechanicProgressCardsState | undefined) {
        super(uiGameManager, devCardsState, progressCardsState)

        if(this.progressCardsState) this.initBankControllerToContainCommodities()
    }

    protected initBankContainer() {
        const canvas = this.uiGameManager.canvasController
        const marginBottom = canvas.itemSize * 0.05
        const heightForTablet = (this.uiGameManager.gameLayout.getHelpSectionHeight() - UIMDeviceHandler.getStatusBarHeight() - 2 * marginBottom)
        const h = UIUtilsEjsVariables.isUserOnTabletApp ? heightForTablet : canvas.itemSize
        const w = UIUtilsEjsVariables.isUserOnTabletApp ? h / UIGameConstants.CARD_RATIO * 6 : canvas.appW * 0.56
        const x = (canvas.appW - w) * 0.5
        const y = this.uiGameManager.gameLayout.getHelpSectionHeight() - marginBottom - h

        this.container = new SectionBgView(x, y, w, h, canvas.app.stage)
        this.container.drawBg(undefined, 0.2)
        this.textColor = GameColor.getColor(GameColor.Color.White)
    }

    protected initBankIcon() {
        const bankIconTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bank)

        const bankIconContainerX = 0
        const bankIconContainerY = 0
        const bankIconContainerWidth = this.container.height
        const bankIconContainerHeight = this.container.height
        this.bankIconContainer = new SectionView(bankIconContainerX, bankIconContainerY, bankIconContainerWidth, bankIconContainerHeight, this.container)

        const bankIconSize = this.container.height * 0.6
        const bankIconX = this.bankIconContainer.width * 0.3
        this.bankIcon = new SpriteView(bankIconX, 0, bankIconSize, bankIconSize, this.bankIconContainer, bankIconTexture)

        this.bankIcon.centerYInParent()
        this.bankIcon.centerXInParent()
    }

    protected initializeCardContainer() {
        const removePadding = true
        this.cardCountViewContainer = new SectionView(this.cardH, 0, this.cardW * 5, this.cardH, this.container, removePadding)
    }

    protected initializeDevelopmentCardContainer(isProgressCard: boolean = false) {
        const isTradeView = false
        const hideBankCards = this.uiGameManager.gameController.gameSettings.hideBankCards

        this.developmentCardCountView = new CardCountView(this.uiGameManager, this.cardH + this.cardW * 5, 0, this.cardW, this.cardH, this.container, CardEnum.DevelopmentBack, this.textColor, isTradeView, hideBankCards)

        if(!isProgressCard) return

        const progressCardTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.card_progress_back)
        this.developmentCardCountView.topCard.view.texture = progressCardTexture
        this.expandBankInterface()
        this.setProgressCardToolTip()
    }

    protected initializeCardDimension() {
        this.cardH = this.container.height * 1.1
        const cardWidth = this.cardH * 0.65 / UIGameConstants.CARD_RATIO
        this.cardW = cardWidth + this.uiGameManager.canvasController.margin * 0.5
    }

    initBankControllerToContainCommodities() {
        this.container.interactive = true
        this.developmentCardCountView.destroy()
        const isProgressCard = true
        this.initializeDevelopmentCardContainer(isProgressCard)
        this.update()
    }

    private expandBankInterface() {
        const margin = this.uiGameManager.canvasController.margin
        const additionCardsToShow = 3
        const additionalCardWidth = this.cardW * additionCardsToShow
        const widthBeingRemoveByHidingBankIcon = this.bankIconContainer.width
        const widthBeingAddedToContainer = additionalCardWidth - widthBeingRemoveByHidingBankIcon - this.uiGameManager.canvasController.itemSize * 0.2
        const extendedWidth = this.container.width + widthBeingAddedToContainer
        const scalingFactor = extendedWidth / this.container.width

        this.container.scale.x *= scalingFactor
        this.cardCountViewContainer.scale.x *= 1 / scalingFactor
        this.developmentCardCountView.scale.x *= 1 / scalingFactor

        this.container.x = (this.uiGameManager.canvasController.appW - this.container.width) / 2
        this.hideBankIcon()
        this.developmentCardCountView.x = this.container.initialPosition.w - this.developmentCardCountView.width - (margin / scalingFactor)
        this.cardCountViewContainer.x = margin / scalingFactor
        const allResourceCardsAndCommodities = 8
        this.showFirstXCards(allResourceCardsAndCommodities)
    }

    private setProgressCardToolTip() {
        this.developmentCardCountView.topCard.view.interactive = true
        this.developmentCardCountView.topCard.view.on('pointerdown', () => this.showProgressCardToolTip())
        this.developmentCardCountView.topCard.view.on('pointerup', () => this.removeProgressCardToolTip())
    }

    private removeProgressCardToolTip() {
        if(this.developmentCardProgressCardToolTipView == undefined) return
        this.developmentCardProgressCardToolTipView.removeToolTip()
        this.developmentCardProgressCardToolTipView = undefined
    }

    private showProgressCardToolTip() {
        const cardCountView = this.developmentCardCountView.topCard
        const bankCards = this.progressCardsState?.bankProgressCards.cards ?? []
        const hideBankCards = this.uiGameManager.gameController.gameSettings.hideBankCards
        const title: TranslationObject = {key: 'strings:game.cards.progress.title.ProgressCards'}
        this.developmentCardProgressCardToolTipView = new UIGameProgressCardsToolTipView(cardCountView, title, bankCards, hideBankCards)
    }

    private hideBankIcon() {
        if(this.bankIconContainer.parent == undefined) return
        this.bankIconContainer.parent.removeChild(this.bankIconContainer)
    }
}
